var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"report-content"},[_c('div',{staticClass:"tracker"},[_vm._v(" "+_vm._s(_vm.report.tracker_name)+" ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"summary"},[_c('div',{staticClass:"title"},[_vm._v(" Executive Summary ")])])
}]

export { render, staticRenderFns }